import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import key from "../../Assets/ContentCreation.jpg";
import key1 from "../../Assets/GraphicDesign.jpg";
import key2 from "../../Assets/SocialMedia.jpg";
import key3 from "../../Assets/About/About/use.jpg";
import key4 from "../../Assets/me-home.jpg";
import key5 from "../../Assets/web-design.jpg";
import key6 from "../../Assets/Hero-image.jpg";
import key7 from "../../Assets/Engagement-Management.jpg";
import key8 from "../../Assets/branding.jpg";

const Section1 = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const portfolioItems = [key, key1, key2, key3, key4, key5, key6, key7, key8];

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % portfolioItems.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? portfolioItems.length - 1 : prev - 1
    );
  };

  const getSlidePosition = (index) => {
    const total = portfolioItems.length;
    const diff = (index - currentIndex + total) % total;

    if (diff === 0) return "center"; // Center/main slide
    if (diff === 1 || diff === -total + 1) return "right"; // Next slide
    if (diff === total - 1 || diff === -1) return "left"; // Previous slide
    return "hidden"; // Everything else
  };

  return (
    <section className=" mx-auto px-4 bg-[#f2efea] py-8 md:py-12">
      <div className="max-w-[1200px] mx-auto ">
        <h2
          className="text-center text-2xl md:text-4xl font-light uppercase tracking-wider mb-6 md:mb-8"
          style={{
            fontFamily: "Blacker Pro Display",
          }}
        >
          Our Portfolio
        </h2>

        <div className="relative">
          {/* Portfolio Images */}
          <div className="flex justify-center items-center relative h-[400px] sm:h-[500px] md:h-[600px]">
            {portfolioItems.map((image, index) => {
              const position = getSlidePosition(index);

              return (
                <div
                  key={`slide-${index}`}
                  className={`absolute transition-all duration-500 ease-in-out ${
                    position === "center"
                      ? "w-[200px] h-[300px] sm:w-[300px] sm:h-[400px] md:w-[400px] md:h-[500px] lg:w-[500px] lg:h-[600px] z-20 scale-100"
                      : position === "left"
                      ? "hidden sm:block w-[150px] h-[200px] sm:w-[200px] sm:h-[300px] md:w-[250px] md:h-[350px] lg:w-[300px] lg:h-[400px] z-10 -translate-x-[150%] opacity-60"
                      : position === "right"
                      ? "hidden sm:block w-[150px] h-[200px] sm:w-[200px] sm:h-[300px] md:w-[250px] md:h-[350px] lg:w-[300px] lg:h-[400px] z-10 translate-x-[150%] opacity-60"
                      : "hidden"
                  }`}
                >
                  <img
                    src={image}
                    alt={`Portfolio item ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              );
            })}

            {/* Navigation arrows beside the main image */}
            <button
              onClick={prevSlide}
              className="absolute top-1/2 left-2 sm:left-[-50px] lg:left-[-70px] transform -translate-y-1/2 p-2 bg-white shadow-md rounded-full text-gray-600 hover:text-gray-900 hover:bg-gray-200 transition-all z-30"
              aria-label="Previous slide"
            >
              <ChevronLeft size={24} />
            </button>

            <button
              onClick={nextSlide}
              className="absolute top-1/2 right-2 sm:right-[-50px] lg:right-[-70px] transform -translate-y-1/2 p-2 bg-white shadow-md rounded-full text-gray-600 hover:text-gray-900 hover:bg-gray-200 transition-all z-30"
              aria-label="Next slide"
            >
              <ChevronRight size={24} />
            </button>
          </div>
        </div>

        <div className="mt-8 md:mt-12 text-center max-w-xs sm:max-w-sm md:max-w-2xl mx-auto">
          <p className="text-sm md:text-base text-gray-700 leading-relaxed px-4">
            Calling all passionate small business owners who pour their heart
            and soul into their brands! If you're all about chasing dreams,
            making a difference, and creating something truly remarkable, then
            you've come to the right place.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Section1;
